enum OrderTypeEnum
{
    STANDARD = "STANDARD",
    BROKERED = "BROKERED",
    OPERATING_LEASE = "OPERATING_LEASE",
    CAR_LOAN = "CAR_LOAN",
}

export default OrderTypeEnum;
